import { Page } from "@react-pdf/renderer";
import { styles } from "./PdfStyles";
import { PdfPageHeader } from "./PdfPageHeader";
import { PdfPageFooter } from "./PdfPageFooter";

/**
 * PdfPageWrapper — wraps each <Page> with the repeating fixed header and footer.
 *
 * Props:
 *   pharmacyProps — { pharmacyName, pharmacyStoreNumber, pharmacyPhone, pharmacyFax, pharmacyEmail }
 *   children      — page content
 */
export const PdfPageWrapper = ({ children, pharmacyProps = {} }) => (
  <Page size="LETTER" style={styles.page}>
    <PdfPageHeader {...pharmacyProps} />
    {children}
    <PdfPageFooter />
  </Page>
);
